import {
  backupBomOptions,
  clearBomOptionsBackup,
  clearCurrentEditedBomOption,
  restoreRecentBomOptionsList,
  setCurrentEditedBomOption,
  setCurrentGalleryItem,
  setNextgenCurrentStep,
  setProductDetailsInterfaceSettings,
} from '../actions';
import {
  getBaseProductGalleryItems,
  getBomOptionsBackup,
  getCurrentBomOption,
  getCurrentGalleryItem,
  getProductDetailsInterfaceSettings,
  getProductGalleryItems,
  getSelectedBomOptionsGalleryItems,
} from './selectors';
import {
  getWhetherCurrentBomOptionGroupCanChangeProductPreviewColor,
  getWhetherHasBomOptionsSelected,
} from '../../bom/selectors';
import { initializeChildOptions, initializeQuantity, initializeUniqueOptions } from '../../bom/actions';

import { changeCurrentBomOption } from '../../imprintarea/logics';
import { generateBomOptionGalleryName } from '../bom-options/utils';
import { getAllNextGenUIImprintAreaKeys } from '../../imprintarea/selectors';
import { isInternalBrand } from '../../main/selectors';
import { nextgenUiSteps } from '../../main/constants';

export const initializeProductDetailsAsync = () => {
  return (dispatch, getState) => {
    const state = getState();

    const hasBomOptionsSelected = getWhetherHasBomOptionsSelected(state);
    const editingMode = hasBomOptionsSelected;

    const internalBrand = isInternalBrand(state);
    const imprintAreaKeys = getAllNextGenUIImprintAreaKeys(state);
    const showAsModal = internalBrand && imprintAreaKeys.length > 0;

    dispatch(setProductDetailsInterfaceSettings({ editingMode, showAsModal }));
  };
};

export const showProductDetailsAsync = (selectedBomOption) => {
  return (dispatch, getState) => {
    const state = getState();

    let currentBomOption = getCurrentBomOption(state);
    const equalToCurrentBomOption =
      !!selectedBomOption &&
      !!currentBomOption &&
      selectedBomOption.code === currentBomOption.code &&
      selectedBomOption.codeValue === currentBomOption.codeValue;

    if (!!selectedBomOption && !equalToCurrentBomOption) {
      currentBomOption = selectedBomOption;
      dispatch(changeCurrentBomOption(selectedBomOption));
    }

    if (!!currentBomOption) {
      dispatch(setCurrentEditedBomOption({ ...currentBomOption, isSelected: true }));
    }

    const selectedBomOptionsGalleryItems = getSelectedBomOptionsGalleryItems(state);
    const galleryItems = getProductGalleryItems(state);
    dispatch(
      setCurrentGalleryItem(
        !!currentBomOption && selectedBomOptionsGalleryItems.length > 0
          ? generateBomOptionGalleryName(currentBomOption, state.specs)
          : galleryItems.length > 0
          ? galleryItems[0].name
          : ''
      )
    );

    const settings = getProductDetailsInterfaceSettings(state);
    const { showAsModal } = settings;

    if (showAsModal) {
      const { childOptions, nextgenUi, quantity, uniqueOptions } = state;
      const { recentBomOptions } = nextgenUi.productDetailsInterfaceBuffer;
      dispatch(backupBomOptions({ childOptions, quantity, recentBomOptions, uniqueOptions }));
      dispatch(setProductDetailsInterfaceSettings({ showing: true }));
    }

    dispatch(setNextgenCurrentStep(nextgenUiSteps.ProductDetails));
  };
};

export const hideProductDetailsAsync = ({ acceptBomOptions = false }) => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(clearCurrentEditedBomOption());
    dispatch(setCurrentGalleryItem(''));

    const settings = getProductDetailsInterfaceSettings(state);
    const { editingMode, showAsModal } = settings;

    if (acceptBomOptions && !editingMode) {
      dispatch(setProductDetailsInterfaceSettings({ editingMode: true }));
    }

    if (showAsModal) {
      if (!acceptBomOptions) {
        const bomOptionsBackup = getBomOptionsBackup(state);
        const { childOptions, quantity, recentBomOptions, uniqueOptions } = bomOptionsBackup;
        dispatch(initializeChildOptions(childOptions));
        dispatch(initializeQuantity(quantity));
        dispatch(initializeUniqueOptions(uniqueOptions));
        dispatch(restoreRecentBomOptionsList(recentBomOptions));
      }
      dispatch(clearBomOptionsBackup());
      dispatch(setProductDetailsInterfaceSettings({ showing: false }));
    }
  };
};

export const updateCurrentGalleryItemAsync = (dispatchedBomOption) => {
  return (dispatch, getState) => {
    const state = getState();

    const { code } = dispatchedBomOption;
    const canChangeProductPreviewColor = getWhetherCurrentBomOptionGroupCanChangeProductPreviewColor(state, code);
    if (!canChangeProductPreviewColor) return;

    const { isSelected } = dispatchedBomOption;
    const currentGalleryItem = getCurrentGalleryItem(state);

    let newGalleryItem = generateBomOptionGalleryName(dispatchedBomOption, state.specs);
    if (!isSelected && newGalleryItem !== currentGalleryItem) return;

    if (!isSelected) {
      const selectedBomOptionsGalleryItems = getSelectedBomOptionsGalleryItems(state);
      const baseProductGalleryItems = getBaseProductGalleryItems(state);
      newGalleryItem =
        selectedBomOptionsGalleryItems.length > 0
          ? selectedBomOptionsGalleryItems[0].name
          : baseProductGalleryItems.length > 0
          ? baseProductGalleryItems[0].name
          : '';
    }
    dispatch(setCurrentGalleryItem(newGalleryItem));
  };
};
